import { render } from "./Home.vue?vue&type=template&id=398c0e6c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=398c0e6c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\nicol\\Code\\portfolio_new\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398c0e6c"]])

export default __exports__